// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "PreFooter-module--wrapper--UU7Ar";
export var infoWrapper = "PreFooter-module--infoWrapper--hwjwf";
export var title = "PreFooter-module--title--2s0Ze";
export var subtitle = "PreFooter-module--subtitle--6Z12R";
export var buttonWrapper = "PreFooter-module--buttonWrapper--2D7uq";
export var additionalInfoWrapper = "PreFooter-module--additionalInfoWrapper--WQIvF";
export var decoratorWrapper = "PreFooter-module--decoratorWrapper--Bw51K";